import { render, staticRenderFns } from "./Information-Bottom.vue?vue&type=template&id=3feac779&"
import script from "./Information-Bottom.vue?vue&type=script&lang=js&"
export * from "./Information-Bottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports